<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.group_practice_periods', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <GroupPracticesForm :group-practice="groupPractice" :options="options" :meta="meta" :url="meta.links.store" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupPracticesForm from './partials/GroupPracticesForm.vue';

export default {
    components: {
        PanelPage,
        GroupPracticesForm,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            groupPractice: {
                title: this.meta.default.title,
                mode: this.meta.default.mode,
                group_id: this.meta.default.group_id,
                subject_id: this.meta.default.subject_id,
                minutes: this.meta.default.minutes,
                published_at: this.meta.default.published_at,
                unpublished_at: this.meta.default.unpublished_at,
                tag_ids: this.meta.default.tag_ids,
                student_ids: this.meta.default.student_ids,
                should_exclude_when_time_away: this.meta.default.should_exclude_when_time_away,
            },
            contentBlocks: this.options.blocks,
            students: this.options.students,
        };
    },
};
</script>
